import '../SystemSettings/SystemSettings.css';

import { CSSProperties, ClassNameMap } from '@material-ui/styles';
import { ISaveSystemSettingsParams, ISystemSettings } from '../../helpers/interfaces';
import React, { ChangeEvent } from 'react';
import { closeSaveParametersSettingsNotification, saveSystemSettings, saveW2SystemSettings, saveW2SystemExtendedSettings, getClients, saveSystemClients } from '../../stores/actions/installerActions';
import { emptyHeaderStyle, loaderStyleEmptyCard } from '../../helpers/CustomStyles';

import SystemIcon from '../ShortStatus/SystemIcon';
import Button from '@material-ui/core/Button';
import Card from '../../../components/Card/CardTS';
import CardBody from '../../../components/Card/CardBody';
import CardHeader from '../../../components/Card/CardHeaderTS';
import CardIcon from '../../../components/Card/CardIcon.js';
import Divider from '@material-ui/core/Divider';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import Loading from '../Loading/Loading';
import MenuItem from '@material-ui/core/MenuItem';
import Snackbar from '../../../components/Snackbar/Snackbar.js';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { connect } from 'react-redux';
import dashboardStyle from '../../../assets/jss/material-dashboard-pro-react/views/dashboardStyleTS';
import utils from '../../helpers/GlobalVariables';
import { MuiPickersUtilsProvider, DatePicker, TimePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import { SYSTEM_VERSIONS } from '../../helpers/Systems';

interface ISystemParametersSettingsProps {
	saveParametersSettingsFailed: boolean;
	saveParametersSettingsSuccessfully: boolean;
	saveParametersSettingsFailedReason: string;
	isMapLoading: boolean;
	mobileView: boolean;
	classes: ClassNameMap;
	currentSystem: ISystemSettings;
	accountCategory: string;
	closeSaveParametersSettingsNotification: () => void;
	saveSystemSettings: (saveSystemSettingsParams: ISaveSystemSettingsParams) => void;
	saveW2SystemSettings: (newSettings, oldSettings) => void;
	saveW2SystemExtendedSettings: (settings) => void;
	clients: { ID: number; name: string }[] | null;
	getClients: () => void;
	saveSystemClients: (systemID: number, buyerClientId: number | null, servicePurchaserClientId: number | null) => void;
}

interface ISystemParametersSettingsState {
	winterSeasonStartError: boolean;
	winterSeasonEndError: boolean;
	heartbeatError: boolean;
	rainstormModeEndError: boolean;
	summertimeMeasurementPeriodError: boolean;
	wintertimeMeasurementPeriodError: boolean;
	communicationPeriodError: boolean;
	hysteresisForDistanceError: boolean;
	hysteresisForAngleError: boolean;
	nameError: boolean;
    addressStreetError: boolean;
	addressBuildingNumberError: boolean;
	addressPostalCodeError: boolean;
	addressCityError: boolean;
	w2SystemIdError: boolean;
	latitudeError: boolean;
	longitudeError: boolean;
	inclinometerRangeError: boolean;
	obstructionChangeThresholdError: boolean;
	obstructionCancelThresholdError: boolean;
	dailyMeasurementTimeError: boolean;
	dailyMeasurementOnError: boolean;
	autoRainstormModeEnabledError: boolean;
	nameValue: string;
	countryValue: string;
	addressStreetValue: string;
	addressBuildingNumberValue: string;
	addressPostalCodeValue: string;
	addressCityValue: string;
	languageValue: string;
	timeZoneValue: string;
	winterSeasonStartValue: string;
	winterSeasonEndValue: string;
	heartbeatValue: string;
	rainstormModeEndValue: string;
	rainstormModeEndTime: string;
	summertimeMeasurementPeriodValue: string;
	wintertimeMeasurementPeriodValue: string;
	communicationPeriodValue: string;
	obstructionDetectionThresholdValue: number;
	obstructionChangeThresholdValue: number;
	obstructionCancelThresholdValue: number;
	hysteresisForDistanceValue: number;
	hysteresisForAngleValue: number;
	w2SystemIdValue: string;
	latitudeValue: string;
	longitudeValue: string;
	inclinometerRangeValue: string;
	dailyMeasurementTimeValue: string;
	dailyMeasurementOnValue: boolean;
	autoRainstormModeEnabledValue: boolean;
	angleChangeThresholdValue: number;
	angleChangeThresholdError: boolean;
	distanceChangeThresholdValue: number;
	distanceChangeThresholdError: boolean;
	isLoaderRender: boolean;
	isFirstRender: boolean;
	isDataLoaded: boolean;
	w2PublicIpAddressValue: string;
	w2PublicIpAddressError: boolean;
	w2PublicIpAddressDisabledValue: boolean;
	w2HttpPortValue: string;
	w2HttpPortError: boolean;
	w2HttpsPortValue: string;
	w2HttpsPortError: boolean;
	w2SshPortValue: string;
	w2SshPortError: boolean;
	syncSettingValue: string;
	// '' when no client is assigned
	buyerClientIdValue: number | '';
	servicePurchaserClientIdValue: number | '';
}

type validatorType = 'name' | 'shortDate' | 'time' | 'date' | 'simpleInt' | 'angle' | 'latitude' | 'longitude' | 'postalCode' |
					 'buildingNumber' | 'nullableString' | 'measurementPeriod' | 'inclinometerRange' | 'communicationPeriod' |
					 'angleChangeThreshold' | 'distanceChangeThreshold' | 'port';
type inputId =
	| 'name'
	| 'winterSeasonStart'
	| 'winterSeasonEnd'
	| 'heartbeat'
	| 'summertimeMeasurementPeriod'
	| 'wintertimeMeasurementPeriod'
	| 'hysteresisForDistance'
	| 'hysteresisForAngle'
	| 'w2SystemId'
	| 'latitude'
	| 'longitude'
	| 'inclinometerRange'
	| 'dailyMeasurementTime'
	| 'communicationPeriod'
	| 'angleChangeThreshold'
	| 'distanceChangeThreshold'
	| 'w2PublicIpAddress'
	| 'w2HttpPort'
	| 'w2HttpsPort'
	| 'w2SshPort';
type selectId =
	| 'country'
	| 'timeZone'
	| 'language'
	| 'rainstormModeEnd'
	| 'obstructionDetectionThreshold'
	| 'obstructionCancelThreshold'
	| 'obstructionChangeThreshold'
	| 'summertimeMeasurementPeriod'
	| 'wintertimeMeasurementPeriod'
	| 'dailyMeasurementOn'
	| 'autoRainstormModeEnabled'
	| 'w2PublicIpAddressDisabled'
	| 'syncSetting';

const w2WiseneOnlyEditableIds: string[] = [
	'name', 'addressStreet', 'addressBuildingNumber', 'addressPostalCode', 'addressCity', 'w2SystemId',
	'w2PublicIpAddress', 'w2HttpPort', 'w2HttpsPort', 'w2SshPort',
];
class SystemParametersSettings extends React.Component<ISystemParametersSettingsProps, ISystemParametersSettingsState> {
	state = {
		winterSeasonStartError: false,
		winterSeasonEndError: false,
		heartbeatError: false,
		rainstormModeEndError: false,
		summertimeMeasurementPeriodError: false,
		wintertimeMeasurementPeriodError: false,
		communicationPeriodError: false,
		hysteresisForDistanceError: false,
		hysteresisForAngleError: false,
		nameError: false,
		w2SystemIdError: false,
        addressStreetError: false,
	    addressBuildingNumberError: false,
	    addressPostalCodeError: false,
	    addressCityError: false,
		dailyMeasurementTimeError: false,
		dailyMeasurementOnError: false,
		autoRainstormModeEnabledError: false,
		nameValue: null,
		countryValue: null,
        addressStreetValue: null,
	    addressBuildingNumberValue: null,
	    addressPostalCodeValue: null,
	    addressCityValue: null,
		languageValue: null,
		timeZoneValue: null,
		winterSeasonStartValue: null,
		winterSeasonEndValue: null,
		heartbeatValue: null,
		rainstormModeEndValue: null,
		rainstormModeEndTime: null,
		summertimeMeasurementPeriodValue: null,
		wintertimeMeasurementPeriodValue: null,
		communicationPeriodValue: 300,
		obstructionDetectionThresholdValue: null,
		obstructionChangeThresholdValue: null,
		obstructionCancelThresholdValue: null,
		hysteresisForDistanceValue: null,
		hysteresisForAngleValue: null,
		w2SystemIdValue: null,
		latitudeValue: null,
		latitudeError: false,
		longitudeValue: null,
		longitudeError: false,
		inclinometerRangeValue: null,
		inclinometerRangeError: false,
		dailyMeasurementTimeValue: null,
		dailyMeasurementOnValue: false,
		autoRainstormModeEnabledValue: true,
		angleChangeThresholdValue: null,
		angleChangeThresholdError: false,
		distanceChangeThresholdValue: null,
		distanceChangeThresholdError: false,
		isLoaderRender: false,
		isFirstRender: true,
		isDataLoaded: false,
		obstructionChangeThresholdError: false,
		obstructionCancelThresholdError: false,
		w2PublicIpAddressValue: null,
		w2PublicIpAddressError: false,
		w2PublicIpAddressDisabledValue: false,
		w2HttpPortValue: null,
		w2HttpPortError: false,
		w2HttpsPortValue: null,
		w2HttpsPortError: false,
		w2SshPortValue: null,
		w2SshPortError: false,
		syncSettingValue: 'on-line',
		buyerClientIdValue: '',
		servicePurchaserClientIdValue: '',
	};

	//TODO: fill lists of time zones and countries
	closeSaveParametersSettingsTimeout = null;
	languages = [{ value: 'en', label: 'English' }];
	timezones = [
		{ value: 'Europe/London', label: 'Europe/London' },
		{ value: 'Europe/Warsaw', label: 'Europe/Warsaw' },
	];
	countries = [{ value: 'PL', label: 'PL' }];
	syncSettings = [
		{ value: 'on-line', label: 'On-line' },
		{ value: 'sms-only', label: 'SMS only' },
		{ value: 'off-line', label: 'Off-line' },
	];
	obstructionDetectionThresholds = [
		{ value: '5', label: '5mm' },
		{ value: '10', label: '10mm' },
		{ value: '20', label: '20mm' },
		{ value: '30', label: '30mm' },
		{ value: '40', label: '40mm' },
		{ value: '50', label: '50mm' },
	];
	obstructionCancelThresholds = [
		{ value: '5', label: '5mm' },
		{ value: '10', label: '10mm' },
		{ value: '20', label: '20mm' },
		{ value: '30', label: '30mm' },
		{ value: '40', label: '40mm' },
		{ value: '50', label: '50mm' },
	];
	obstructionChangeThresholds = [
		{ value: '5', label: '5mm' },
		{ value: '10', label: '10mm' },
		{ value: '15', label: '15mm' },
		{ value: '20', label: '20mm' },
		{ value: '25', label: '25mm' },
	];

	// value in milliseconds:
	rainstormModeEndPeriod = [
		{ value: '0', label: 'Off' },
		{ value: '3600000', label: '1h' },
		{ value: '7200000', label: '2h' },
		{ value: '10800000', label: '3h' },
		{ value: '14400000', label: '4h' },
		{ value: '18000000', label: '5h' },
		{ value: '21600000', label: '6h' },
		{ value: '25200000', label: '7h' },
		{ value: '28800000', label: '8h' },
		{ value: '32400000', label: '9h' },
		{ value: '36000000', label: '10h' },
		{ value: '39600000', label: '11h' },
		{ value: '432000000', label: '12h' },
	];
	selectsStyle = { marginBottom: '22px' };
	gridsStyle: CSSProperties = { marginBottom: '10px', padding: '0', height: '81px' };

	componentDidMount() {
		this.props.closeSaveParametersSettingsNotification();
		if (!Array.isArray(this.props.clients)) {
			this.props.getClients();
		}
		if (!this.props.isMapLoading && this.props.currentSystem && this.state.isFirstRender) {
			const {
				country,
				timeZone,
				winterSeasonStart,
				winterSeasonEnd,
				heartbeatTime,
				rainstormModeEnd,
				summertimeMeasurementPeriod,
				wintertimeMeasurementPeriod,
				communicationPeriod,
				obstructionCancelThreshold,
				obstructionDetectionThreshold,
				obstructionChangeThreshold,
				hysteresisForDistance,
				hysteresisForAngle,
				name,
				W2SystemId,
				latitude,
				longitude,
				addressStreet,
				addressPostalCode,
				addressBuildingNumber,
				addressCity,
				dailyMeasurementTime,
				dailyMeasurementOn,
				autoRainstormModeEnabled,
				angleChangeThreshold,
				distanceChangeThreshold,
				inclinometerRange,
				w2PublicIpAddress,
				w2PublicIpAddressDisabled,
				w2HttpPort,
				w2HttpsPort,
				w2SshPort,
				syncSetting,
				buyerClientId,
				servicePurchaserClientId
			} = this.props.currentSystem;

			this.setState({
				nameValue: name,
				countryValue: country,
				languageValue: 'en',
				timeZoneValue: timeZone,
				winterSeasonStartValue: utils.parseDateFromDb(winterSeasonStart),
				winterSeasonEndValue: utils.parseDateFromDb(winterSeasonEnd),
				heartbeatValue: !heartbeatTime ? '' : heartbeatTime.Time.split('T')[1].split('Z')[0].slice(0, -3),
				rainstormModeEndTime: rainstormModeEnd?.Time,
				rainstormModeEndValue: this.rainstormModeEndPeriod[0].value,
				summertimeMeasurementPeriodValue: this.convertSecondsToTime(summertimeMeasurementPeriod),
				wintertimeMeasurementPeriodValue: this.convertSecondsToTime(wintertimeMeasurementPeriod),
				communicationPeriodValue: this.convertSecondsToTime(communicationPeriod),
				obstructionDetectionThresholdValue: obstructionDetectionThreshold,
				obstructionChangeThresholdValue: obstructionChangeThreshold,
				obstructionCancelThresholdValue: obstructionCancelThreshold,
				hysteresisForDistanceValue: hysteresisForDistance,
				hysteresisForAngleValue: hysteresisForAngle,
				w2SystemIdValue: W2SystemId?.String,
				latitudeValue: latitude?.Valid ? latitude.Float64.toString() : '',
				longitudeValue: longitude?.Valid ? longitude.Float64.toString() : '',
				addressStreetValue: addressStreet,
				addressBuildingNumberValue: addressBuildingNumber,
				addressPostalCodeValue: addressPostalCode,
				addressCityValue: addressCity,
				dailyMeasurementTimeValue: this.formatDailyMeasurementTime(dailyMeasurementTime),
				dailyMeasurementOnValue: dailyMeasurementOn,
				autoRainstormModeEnabledValue: autoRainstormModeEnabled,
				angleChangeThresholdValue: angleChangeThreshold,
				distanceChangeThresholdValue: distanceChangeThreshold,
				inclinometerRangeValue: inclinometerRange?.toString(),
				w2PublicIpAddressValue: w2PublicIpAddress,
				w2PublicIpAddressDisabledValue: !!w2PublicIpAddressDisabled,
				w2HttpPortValue: w2HttpPort != null ? w2HttpPort.toString() : null,
				w2HttpsPortValue: w2HttpsPort != null ? w2HttpsPort.toString() : null,
				w2SshPortValue: w2SshPort != null ? w2SshPort.toString() : null,
				syncSettingValue: syncSetting ?? 'on-line',
				buyerClientIdValue: buyerClientId ?? '',
				servicePurchaserClientIdValue: servicePurchaserClientId ?? '',
				isFirstRender: false,
				isDataLoaded: true,
			});
		}
	}

	componentDidUpdate() {
		if (this.props.saveParametersSettingsSuccessfully || this.props.saveParametersSettingsFailed) {
			if (this.state.isLoaderRender) {
				this.setState({ isLoaderRender: false });
			}
			this.closeSaveParametersSettingsTimeout = setTimeout(this.props.closeSaveParametersSettingsNotification, 6000);
		}
		if (!this.props.isMapLoading && this.props.currentSystem && this.state.isFirstRender) {
			const {
				country,
				timeZone,
				winterSeasonStart,
				winterSeasonEnd,
				heartbeatTime,
				rainstormModeEnd,
				summertimeMeasurementPeriod,
				wintertimeMeasurementPeriod,
				communicationPeriod,
				obstructionCancelThreshold,
				obstructionDetectionThreshold,
				obstructionChangeThreshold,
				hysteresisForDistance,
				hysteresisForAngle,
				name,
				W2SystemId,
				latitude,
				longitude,
                addressStreet,
				addressPostalCode,
				addressBuildingNumber,
				addressCity,
				dailyMeasurementTime,
				dailyMeasurementOn,
				autoRainstormModeEnabled,
				angleChangeThreshold,
				distanceChangeThreshold,
				inclinometerRange,
				w2PublicIpAddress,
				w2PublicIpAddressDisabled,
				w2HttpPort,
				w2HttpsPort,
				w2SshPort,
				syncSetting,
				buyerClientId,
				servicePurchaserClientId
			} = this.props.currentSystem;

			this.setState({
				nameValue: name,
				countryValue: country,
				languageValue: 'en',
				timeZoneValue: timeZone,
				winterSeasonStartValue: utils.parseDateFromDb(winterSeasonStart),
				winterSeasonEndValue: utils.parseDateFromDb(winterSeasonEnd),
				heartbeatValue: !heartbeatTime ? '' : heartbeatTime.Time.split('T')[1].split('Z')[0].slice(0, -3),
				rainstormModeEndTime: rainstormModeEnd?.Time,
				rainstormModeEndValue: this.rainstormModeEndPeriod[0].value,
				summertimeMeasurementPeriodValue: this.convertSecondsToTime(summertimeMeasurementPeriod),
				wintertimeMeasurementPeriodValue: this.convertSecondsToTime(wintertimeMeasurementPeriod),
				communicationPeriodValue: this.convertSecondsToTime(communicationPeriod),
				obstructionDetectionThresholdValue: obstructionDetectionThreshold,
				obstructionChangeThresholdValue: obstructionChangeThreshold,
				obstructionCancelThresholdValue: obstructionCancelThreshold,
				hysteresisForDistanceValue: hysteresisForDistance,
				hysteresisForAngleValue: hysteresisForAngle,
				w2SystemIdValue: W2SystemId?.String,
				latitudeValue: latitude?.Valid ? latitude.Float64.toString() : '',
				longitudeValue: longitude?.Valid ? longitude.Float64.toString() : '',
				addressStreetValue: addressStreet,
				addressBuildingNumberValue: addressBuildingNumber,
				addressPostalCodeValue: addressPostalCode,
				addressCityValue: addressCity,
				dailyMeasurementTimeValue: this.formatDailyMeasurementTime(dailyMeasurementTime),
				dailyMeasurementOnValue: dailyMeasurementOn,
				autoRainstormModeEnabledValue: autoRainstormModeEnabled,
				angleChangeThresholdValue: angleChangeThreshold,
				distanceChangeThresholdValue: distanceChangeThreshold,
				inclinometerRangeValue: inclinometerRange?.toString(),
				w2PublicIpAddressValue: w2PublicIpAddress,
				w2PublicIpAddressDisabledValue: !!w2PublicIpAddressDisabled,
				w2HttpPortValue: w2HttpPort != null ? w2HttpPort.toString() : null,
				w2HttpsPortValue: w2HttpsPort != null ? w2HttpsPort.toString() : null,
				w2SshPortValue: w2SshPort != null ? w2SshPort.toString() : null,
				syncSettingValue: syncSetting ?? 'on-line',
				buyerClientIdValue: buyerClientId ?? '',
				servicePurchaserClientIdValue: servicePurchaserClientId ?? '',
				isFirstRender: false,
				isDataLoaded: true,
			});
		}
	}

	componentWillUnmount() {
		clearTimeout(this.closeSaveParametersSettingsTimeout);
		this.closeSaveParametersSettingsTimeout = null;
	}

    convertSecondsToTime(seconds: number){
		let hours = Math.floor(seconds / 3600);
		let minutes = Math.floor((seconds % 3600) / 60);
	  
		let formattedHours = String(hours).padStart(2, '0');
		let formattedMinutes = String(minutes).padStart(2, '0');
	  
		return `${formattedHours}:${formattedMinutes}`;
    }

    convertTimeToSeconds(time: string){
		let [hours, minutes] = time.split(':').map(Number);
		return (hours * 3600) + (minutes * 60);
    }

	// empty inputs of nullable db columns must be saved as NULL, not '' or 0:
	emptyToNull(value: string): string | null {
		return value?.trim() ? value : null;
	}

	parseNullableFloat(value: string): number | null {
		return value?.toString().trim() ? parseFloat(value) : null;
	}

	formatDailyMeasurementTime(dailyMeasurementTime: any): string {
		return !dailyMeasurementTime ? '' : dailyMeasurementTime.split('T')[1].split('Z')[0].slice(0, -3);
	}

	handleSelect = (e: ChangeEvent<{ name?: string; value: unknown }>): void => {
		let currentValue = (e.target as HTMLInputElement).value;
		const currentName = (e.target as HTMLInputElement).name + 'Value';
		if (currentName === 'obstructionChangeThresholdValue') {
			this.setState({
				obstructionChangeThresholdError: +currentValue > +this.state.obstructionDetectionThresholdValue,
			});
		}
		if (currentName === 'obstructionDetectionThresholdValue') {
			this.setState({
				obstructionChangeThresholdError: +currentValue < +this.state.obstructionChangeThresholdValue,
				obstructionCancelThresholdError: +currentValue < +this.state.obstructionCancelThresholdValue,
			});
		}
		if (currentName === 'obstructionCancelThresholdValue') {
			this.setState({
				obstructionCancelThresholdError: +currentValue > +this.state.obstructionDetectionThresholdValue,
			});
		}

		this.setState((state) => ({ ...state, [currentName]: currentValue }));
	};

	handleSaveParametersSettingsButton = (): void => {
		this.setState({ isLoaderRender: true });
		this.props.closeSaveParametersSettingsNotification();
		const {
			nameValue,
			languageValue,
			countryValue,
			timeZoneValue,
			winterSeasonStartValue,
			winterSeasonEndValue,
			heartbeatValue,
			rainstormModeEndValue,
			rainstormModeEndTime,
			summertimeMeasurementPeriodValue,
			wintertimeMeasurementPeriodValue,
			communicationPeriodValue,
			obstructionDetectionThresholdValue,
			obstructionChangeThresholdValue,
			obstructionCancelThresholdValue,
			hysteresisForDistanceValue,
			hysteresisForAngleValue,
			latitudeValue,
			longitudeValue,
            addressStreetValue,
            addressBuildingNumberValue,
            addressPostalCodeValue,
            addressCityValue,
			dailyMeasurementTimeValue,
			dailyMeasurementOnValue,
			autoRainstormModeEnabledValue,
			angleChangeThresholdValue,
			distanceChangeThresholdValue,
			inclinometerRangeValue,
			w2SystemIdValue,
			w2PublicIpAddressValue,
			w2PublicIpAddressDisabledValue,
			w2HttpPortValue,
			w2HttpsPortValue,
			w2SshPortValue,
			syncSettingValue,
			buyerClientIdValue,
			servicePurchaserClientIdValue
		} = this.state;
		const { currentSystem, accountCategory } = this.props;

		// clients are saved separately, for W2 and W4 systems alike
		const clientsChanged =
			buyerClientIdValue !== (currentSystem.buyerClientId ?? '') ||
			servicePurchaserClientIdValue !== (currentSystem.servicePurchaserClientId ?? '');
		if (clientsChanged) {
			this.props.saveSystemClients(currentSystem.ID, buyerClientIdValue || null, servicePurchaserClientIdValue || null);
		}

		if (currentSystem.systemVersion === SYSTEM_VERSIONS.W4) {
			this.props.saveSystemSettings({
				systemID: currentSystem.ID,
				updatedAt: currentSystem.UpdatedAt.Time.slice(0, -1).replace('T', ' '),
				name: nameValue,
				country: countryValue,
				language: languageValue,
				timezone: timeZoneValue,
				winterSeasonStart: utils.parseDateFromPickerToDb(winterSeasonStartValue),
				winterSeasonEnd: utils.parseDateFromPickerToDb(winterSeasonEndValue),
				heartbeatTime: heartbeatValue,
				rainstormModeEnd: utils.calculateRainstormModeDate(rainstormModeEndTime, rainstormModeEndValue),
				summertimeMeasurementPeriod: this.convertTimeToSeconds(summertimeMeasurementPeriodValue),
				wintertimeMeasurementPeriod:  this.convertTimeToSeconds(wintertimeMeasurementPeriodValue),
				communicationPeriod: this.convertTimeToSeconds(communicationPeriodValue),
				obstructionDetectionThreshold: parseInt(obstructionDetectionThresholdValue, 10),
				obstructionChangeThreshold: parseInt(obstructionChangeThresholdValue, 10),
				obstructionCancelThreshold: parseInt(obstructionCancelThresholdValue, 10),
				hysteresisForDistance: parseInt(hysteresisForDistanceValue, 10),
				hysteresisForAngle: parseFloat(hysteresisForAngleValue),
				latitude: this.parseNullableFloat(latitudeValue),
				longitude: this.parseNullableFloat(longitudeValue),
				addressStreet: this.emptyToNull(addressStreetValue),
				addressBuildingNumber: this.emptyToNull(addressBuildingNumberValue),
				addressPostalCode: this.emptyToNull(addressPostalCodeValue),
				addressCity: this.emptyToNull(addressCityValue),
				inclinometerRange: this.parseNullableFloat(inclinometerRangeValue),
				updatedViaWebsiteAt: currentSystem.updatedViaWebsiteAt,
				angleChangeThreshold: parseFloat(angleChangeThresholdValue),
				distanceChangeThreshold: parseFloat(distanceChangeThresholdValue),
				autoRainstormModeEnabled: autoRainstormModeEnabledValue
			});
		} else {
			const w2ControllerConfigChanged =
				this.convertTimeToSeconds(summertimeMeasurementPeriodValue) !== currentSystem.summertimeMeasurementPeriod ||
				this.convertTimeToSeconds(wintertimeMeasurementPeriodValue) !== currentSystem.wintertimeMeasurementPeriod ||
				dailyMeasurementOnValue !== currentSystem.dailyMeasurementOn ||
				dailyMeasurementTimeValue !== this.formatDailyMeasurementTime(currentSystem.dailyMeasurementTime);

			if (w2ControllerConfigChanged) {
				this.props.saveW2SystemSettings({
					systemID: currentSystem.ID,
					summertimeMeasurementPeriod: this.convertTimeToSeconds(summertimeMeasurementPeriodValue),
					wintertimeMeasurementPeriod: this.convertTimeToSeconds(wintertimeMeasurementPeriodValue),
					dailyMeasurementTime: dailyMeasurementTimeValue,
					dailyMeasurementOn: dailyMeasurementOnValue,
					w2ConfigurationUpdatedAt: currentSystem.w2ConfigurationUpdatedAt
				},
				{
					systemID: currentSystem.ID,
					summertimeMeasurementPeriod: currentSystem.summertimeMeasurementPeriod,
					wintertimeMeasurementPeriod: currentSystem.wintertimeMeasurementPeriod,
					dailyMeasurementTime: currentSystem.dailyMeasurementTime,
					dailyMeasurementOn: currentSystem.dailyMeasurementOn,
					w2ConfigurationUpdatedAt: currentSystem.w2ConfigurationUpdatedAt
				});
			}

			if (accountCategory === 'wisene') {
				this.props.saveW2SystemExtendedSettings({
					systemID: currentSystem.ID,
					updatedViaWebsiteAt: currentSystem.updatedViaWebsiteAt,
					name: nameValue,
					addressStreet: this.emptyToNull(addressStreetValue),
					addressBuildingNumber: this.emptyToNull(addressBuildingNumberValue),
					addressPostalCode: this.emptyToNull(addressPostalCodeValue),
					addressCity: this.emptyToNull(addressCityValue),
					externalSystemId: w2SystemIdValue,
					w2PublicIpAddress: this.emptyToNull(w2PublicIpAddressValue),
					w2PublicIpAddressDisabled: w2PublicIpAddressDisabledValue,
					w2HttpPort: w2HttpPortValue ? parseInt(w2HttpPortValue, 10) : null,
					w2HttpsPort: w2HttpsPortValue ? parseInt(w2HttpsPortValue, 10) : null,
					w2SshPort: w2SshPortValue ? parseInt(w2SshPortValue, 10) : null,
					syncSetting: syncSettingValue,
				});
			} else if (!w2ControllerConfigChanged && !clientsChanged) {
				this.setState({ isLoaderRender: false });
			}
		}
	};

	renderButton = (): JSX.Element => {
		const { isLoaderRender } = this.state;
		const { saveParametersSettingsSuccessfully, saveParametersSettingsFailed } = this.props;

		return (
			<>
				{isLoaderRender ? (
					<div style={{ margin: '10px 0', paddingLeft: '10px', paddingTop: '5px' }}>
						<Loading transform={1} height={17} width={40} color='darkGray' />
					</div>
				) : (
					<Button
						id='saveParametersSettingsButton'
						onClick={this.handleSaveParametersSettingsButton}
						size='large'
						disabled={
							saveParametersSettingsSuccessfully ||
							saveParametersSettingsFailed ||
							!this.state.w2SystemIdValue &&
							(
								this.state.winterSeasonStartError ||
								this.state.winterSeasonEndError ||
								this.state.heartbeatError ||
								this.state.rainstormModeEndError ||
								this.state.summertimeMeasurementPeriodError ||
								this.state.wintertimeMeasurementPeriodError ||
								this.state.communicationPeriodError ||
								this.state.hysteresisForDistanceError ||
								this.state.hysteresisForAngleError ||
								this.state.nameError ||
								this.state.w2SystemIdError ||
								this.state.latitudeError ||
								this.state.longitudeError ||
								this.state.obstructionChangeThresholdError ||
								this.state.obstructionCancelThresholdError ||
								this.state.addressStreetError ||
								this.state.addressBuildingNumberError ||
								this.state.addressPostalCodeError ||
								this.state.addressCityError ||
								this.state.inclinometerRangeError ||
								this.state.angleChangeThresholdError ||
								this.state.distanceChangeThresholdError ||
								this.state.autoRainstormModeEnabledError ||
								!this.state.nameValue ||
								!this.state.countryValue ||
								!this.state.languageValue ||
								!this.state.timeZoneValue ||
								!this.state.winterSeasonStartValue ||
								!this.state.winterSeasonEndValue ||
								!this.state.heartbeatValue ||
								!this.state.rainstormModeEndValue ||
								!this.state.summertimeMeasurementPeriodValue ||
								!this.state.wintertimeMeasurementPeriodValue ||
								!this.state.communicationPeriodValue ||
								!this.state.obstructionDetectionThresholdValue ||
								!this.state.obstructionChangeThresholdValue ||
								!this.state.obstructionCancelThresholdValue ||
								!this.state.hysteresisForDistanceValue ||
								!this.state.hysteresisForAngleValue || 
								!this.state.angleChangeThresholdValue && this.state.angleChangeThresholdValue !== 0 ||
								!this.state.distanceChangeThresholdValue
							) ||
							!!this.state.w2SystemIdValue &&
							(
								this.state.summertimeMeasurementPeriodError ||
								this.state.wintertimeMeasurementPeriodError ||
								this.state.dailyMeasurementTimeError ||
								this.state.dailyMeasurementOnError ||
								!this.state.summertimeMeasurementPeriodValue ||
								!this.state.wintertimeMeasurementPeriodValue ||
								!this.state.dailyMeasurementTimeValue ||
								(this.props.accountCategory === 'wisene' && (
									this.state.nameError ||
									this.state.addressStreetError ||
									this.state.addressBuildingNumberError ||
									this.state.addressPostalCodeError ||
									this.state.addressCityError ||
									this.state.w2SystemIdError ||
									this.state.w2PublicIpAddressError ||
									this.state.w2HttpPortError ||
									this.state.w2HttpsPortError ||
									this.state.w2SshPortError ||
									!this.state.nameValue
								))
							)
						}
						style={{ marginTop: '10px', transition: 'color 0.3s' }}
					>
						Save
					</Button>
				)}
			</>
		);
	};

	renderMobileNotifications = (): JSX.Element => {
		const { saveParametersSettingsSuccessfully, saveParametersSettingsFailed, saveParametersSettingsFailedReason, mobileView } = this.props;
		const headerStyle = utils.getHeaderStyle(saveParametersSettingsFailed);

		if (!mobileView) return null;
		if (saveParametersSettingsFailed || saveParametersSettingsSuccessfully) {
			return (
				<h5
					className={
						saveParametersSettingsFailed
							? 'notification-open-save-parameters-settings-fail'
							: 'notification-open-save-parameters-settings-success'
					}
					style={headerStyle}
				>
					{saveParametersSettingsFailed 
						? (saveParametersSettingsFailedReason
							? 'Save parameters settings failed: ' + saveParametersSettingsFailedReason
							: 'Save parameters settings failed'
						)
						: 'Save parameters settings successfully'}
				</h5>
			);
		}
		return <div style={emptyHeaderStyle}></div>;
	};

	handleChange = (e: ChangeEvent, handlerName: validatorType): void => {
		const currentName = e.target.id;
		const currentValue = (e.target as HTMLInputElement).value;
		let validatedResult = null;
		// check which validator should be used:
		if (handlerName === 'name') validatedResult = utils.validateInputChars(currentValue);
		if (handlerName === 'shortDate') validatedResult = utils.validateShortDate(currentValue);
		if (handlerName === 'time') validatedResult = utils.validateTime(currentValue);
		if (handlerName === 'simpleInt') validatedResult = utils.validateSimpleInt(currentValue);
		if (handlerName === 'angle') validatedResult = utils.validateAngle(currentValue);
		if (handlerName === 'latitude') validatedResult = utils.validateLatitude(currentValue);
		if (handlerName === 'longitude') validatedResult = utils.validateLongitude(currentValue);
		if (handlerName === 'postalCode') validatedResult = utils.validatePostalCode(currentValue);
		if (handlerName === 'buildingNumber') validatedResult = utils.validateBuildingNumber(currentValue);
		if (handlerName === 'nullableString') validatedResult = utils.validateNullableString(currentValue);
		if (handlerName === 'measurementPeriod') validatedResult = utils.validateMeasurementPeriod(currentValue);
		if (handlerName === 'inclinometerRange') validatedResult = utils.validateInclinometerRange(currentValue);
		if (handlerName === 'communicationPeriod') validatedResult = utils.validateCommunicationPeriod(currentValue);
		if (handlerName === 'angleChangeThreshold') validatedResult = utils.validateAngleChangeThreshold(currentValue);
		if (handlerName === 'distanceChangeThreshold') validatedResult = utils.validateDistanceChangeThreshold(currentValue);
		if (handlerName === 'port') validatedResult = utils.validatePort(currentValue);

		this.setState((state) => ({ ...state, [currentName + 'Value']: currentValue, [currentName + 'Error']: validatedResult }));
	};

	renderCustomSelect = (id: selectId, label: string): JSX.Element => {
		const { classes, accountCategory } = this.props;
		const { w2SystemIdValue } = this.state;
		const canEditW2Extended = !!w2SystemIdValue && accountCategory === 'wisene';
		const dropdowns = [
			{ name: 'country', options: this.countries, value: this.state.countryValue },
			{ name: 'timeZone', options: this.timezones, value: this.state.timeZoneValue },
			{ name: 'language', options: this.languages, value: this.state.languageValue },
			{
				name: 'rainstormModeEnd',
				options: this.rainstormModeEndPeriod,
				value: this.state.rainstormModeEndValue,
			},
			{
				name: 'obstructionDetectionThreshold',
				options: this.obstructionDetectionThresholds,
				value: this.state.obstructionDetectionThresholdValue,
			},
			{
				name: 'obstructionCancelThreshold',
				options: this.obstructionCancelThresholds,
				value: this.state.obstructionCancelThresholdValue,
				error: this.state.obstructionCancelThresholdError,
				helperText: 'Obstruction cancel threshold can\'t be higher than Obstruction detection threshold',
			},
			{
				name: 'obstructionChangeThreshold',
				options: this.obstructionChangeThresholds,
				value: this.state.obstructionChangeThresholdValue,
				error: this.state.obstructionChangeThresholdError,
				helperText: 'Obstruction change threshold can\'t be higher than Obstruction detection threshold',
			},
			{
				name: 'dailyMeasurementOn',
				options: [{ value: true, label: 'On' }, { value: false, label: 'Off' }],
				value: this.state.dailyMeasurementOnValue,
				error: this.state.dailyMeasurementOnError,
			},
			{
				name: 'autoRainstormModeEnabled',
				options: [{ value: true, label: 'On' }, { value: false, label: 'Off' }],
				value: this.state.autoRainstormModeEnabledValue,
				error: this.state.autoRainstormModeEnabledError,
			},
			{
				name: 'w2PublicIpAddressDisabled',
				options: [{ value: true, label: 'Disabled' }, { value: false, label: 'Enabled' }],
				value: this.state.w2PublicIpAddressDisabledValue,
			},
			{
				name: 'syncSetting',
				options: this.syncSettings,
				value: this.state.syncSettingValue,
			},
		];

		// pick specific select from dropdowns array:
		const select = dropdowns.find(({ name }) => name === id);
		const localStyle = this.gridsStyle;

		const items = select['options'].map((option, index) => {
			return (
				<MenuItem
					classes={{
						root: classes.selectMenuItem,
						selected: classes.selectMenuItemSelected,
					}}
					value={option.value}
					key={`${id}-${index}`}
				>
					{option.label}
				</MenuItem>
			);
		});
		const index = dropdowns.findIndex((el) => el.name === id);
		const error = dropdowns[index]['error'];
		const helperText = dropdowns[index]['helperText']
		return (
			<GridItem xs={12} style={localStyle}>
				<TextField
					select
					id={`${id}`}
					label={`${label}`}
					fullWidth
					onChange={(e) => this.handleSelect(e)}
					style={this.selectsStyle}
					SelectProps={{ value: select.value, name: id }}
					disabled={
						(!w2SystemIdValue && select.name == 'dailyMeasurementOn') ||
						(w2SystemIdValue && select.name !== 'dailyMeasurementOn' &&
							!(canEditW2Extended && ['w2PublicIpAddressDisabled', 'syncSetting'].includes(select.name)))
					}
					className={dropdowns[index]['error'] ? 'showAnimation' : ''}
					helperText={error ? helperText : '' }
					error={error}
				>
					{items}
				</TextField>
			</GridItem>
		);
	};

	// the list of clients is long, so they are picked by typing; editable for W2 systems too
	renderClientAutocomplete = (id: 'buyerClientId' | 'servicePurchaserClientId', label: string): JSX.Element => {
		const clients = Array.isArray(this.props.clients) ? this.props.clients : [];
		const value = clients.find((client) => client.ID === this.state[`${id}Value`]) ?? null;
		return (
			<GridItem xs={12} style={this.gridsStyle}>
				<Autocomplete
					id={id}
					options={clients}
					getOptionLabel={(client) => client.name}
					getOptionSelected={(option, selected) => option.ID === selected.ID}
					value={value}
					onChange={(e, client) => this.setState((state) => ({ ...state, [`${id}Value`]: client?.ID ?? '' }))}
					loading={!Array.isArray(this.props.clients)}
					noOptionsText='No clients'
					renderInput={(params) => <TextField {...params} label={label} fullWidth />}
				/>
			</GridItem>
		);
	};

	renderCustomTextField = (id: inputId, label: string, validatorName: validatorType): JSX.Element => {
		const valuesAndErrors = [
			{ value: this.state.nameValue, error: this.state.nameError, type: 'text' },
			{ value: this.state.winterSeasonStartValue, error: this.state.winterSeasonStartError, type: 'date' },
			{ value: this.state.winterSeasonEndValue, error: this.state.winterSeasonEndError, type: 'date' },
			{ value: this.state.heartbeatValue, error: this.state.heartbeatError, type: 'time' },
			{ value: this.state.rainstormModeEndValue, error: this.state.rainstormModeEndError, type: 'time' },
			{ value: this.state.summertimeMeasurementPeriodValue, error: this.state.summertimeMeasurementPeriodError, type: 'text' },
			{ value: this.state.wintertimeMeasurementPeriodValue, error: this.state.wintertimeMeasurementPeriodError, type: 'text' },
			{ value: this.state.communicationPeriodValue, error: this.state.communicationPeriodError, type: 'text'},
			{ value: this.state.hysteresisForDistanceValue, error: this.state.hysteresisForDistanceError, type: 'text' },
			{ value: this.state.hysteresisForAngleValue, error: this.state.hysteresisForAngleError, type: 'text' },
			{ value: this.state.w2SystemIdValue, error: this.state.w2SystemIdError, type: 'text' },
			{ value: this.state.latitudeValue, error: this.state.latitudeError, type: 'text' },
			{ value: this.state.longitudeValue, error: this.state.longitudeError, type: 'text' },
			{ value: this.state.addressStreetValue, error: this.state.addressStreetError, type: 'text' },
			{ value: this.state.addressBuildingNumberValue, error: this.state.addressBuildingNumberError, type: 'text' },
			{ value: this.state.addressPostalCodeValue, error: this.state.addressPostalCodeError, type: 'text' },
			{ value: this.state.addressCityValue, error: this.state.addressCityError, type: 'text' },
			{ value: this.state.dailyMeasurementTimeValue, error: this.state.dailyMeasurementTimeError, type: 'time' },
			{ value: this.state.inclinometerRangeValue, error: this.state.inclinometerRangeError, type: 'text'},
			{ value: this.state.angleChangeThresholdValue, error: this.state.angleChangeThresholdError, type: 'text'},
			{ value: this.state.distanceChangeThresholdValue, error: this.state.distanceChangeThresholdError, type: 'text'},
			{ value: this.state.w2PublicIpAddressValue, error: this.state.w2PublicIpAddressError, type: 'text'},
			{ value: this.state.w2HttpPortValue, error: this.state.w2HttpPortError, type: 'text'},
			{ value: this.state.w2HttpsPortValue, error: this.state.w2HttpsPortError, type: 'text'},
			{ value: this.state.w2SshPortValue, error: this.state.w2SshPortError, type: 'text'}
		];

		const inputLabels = [
			'name',
			'winterSeasonStart',
			'winterSeasonEnd',
			'heartbeat',
			'rainstormModeEnd',
			'summertimeMeasurementPeriod',
			'wintertimeMeasurementPeriod',
			'communicationPeriod',
			'hysteresisForDistance',
			'hysteresisForAngle',
			'w2SystemId',
			'latitude',
			'longitude',
			'addressStreet',
			'addressBuildingNumber',
			'addressPostalCode',
			'addressCity',
			'dailyMeasurementTime',
			'inclinometerRange',
			'angleChangeThreshold',
			'distanceChangeThreshold',
			'w2PublicIpAddress',
			'w2HttpPort',
			'w2HttpsPort',
			'w2SshPort'
		];
		// index of current rendered element:
		const index = inputLabels.findIndex((el) => el === id);
		const localStyle = this.gridsStyle;
		const textFieldType = valuesAndErrors[index]['type'];
		const currentValue = valuesAndErrors[index]['value'];

		return (
			<GridItem xs={12} style={localStyle}>
				<TextField
					id={id}
					label={label}
					fullWidth
					type={textFieldType}
					error={valuesAndErrors[index]['error']}
					helperText={valuesAndErrors[index]['error'] ? 'Incorrect value' : ' '}
					onChange={(e) => this.handleChange(e, validatorName)}
					inputProps={{
						maxLength: utils.defaultMaxInputLength,
						value: currentValue,
						autoCapitalize: 'off',
					}}
					className={valuesAndErrors[index]['error'] ? 'showAnimation' : ''}
					disabled={
						(!this.state.w2SystemIdValue && ['dailyMeasurementTime', 'w2SystemId'].includes(id)) ||
						(!!this.state.w2SystemIdValue &&
							!['dailyMeasurementTime', 'summertimeMeasurementPeriod', 'wintertimeMeasurementPeriod'].includes(id) &&
							!(this.props.accountCategory === 'wisene' && w2WiseneOnlyEditableIds.includes(id)))}
				/>
			</GridItem>
		);
	};

	handleDateChange = (date: Date, id: inputId): void => {
		const currentId = id + 'Value';
		this.setState({ ...this.state, [currentId]: date });
	};

	renderDatePicker = (id: inputId, label: string): JSX.Element => {
		const { mobileView } = this.props;
		const datePickers = [
			{ pickerLabel: 'Winter season start', value: this.state.winterSeasonStartValue },
			{ pickerLabel: 'Winter season end', value: this.state.winterSeasonEndValue },
		];
		let currentValue: any = datePickers.find(({ pickerLabel }) => pickerLabel === label).value;
		if (!currentValue instanceof Date) {
			currentValue = utils.parseDateFromDb(currentValue)
		}
		return (
			<MuiPickersUtilsProvider utils={DateFnsUtils}>
				<GridItem xs={12} style={{ ...this.gridsStyle, marginBottom: mobileView ? '32px' : '10px' }}>
					<DatePicker
						id={id}
						variant='inline'
						label={label}
						value={currentValue}
						onChange={(date) => this.handleDateChange(date, id)}
						fullWidth
						InputProps={{ endAdornment: <CalendarTodayIcon style={{ color: '#3c4858' }} /> }}
						disabled={!!this.state.w2SystemIdValue}
					/>
				</GridItem>
			</MuiPickersUtilsProvider>
		);
	};

	handleTimeChange = (date: Date, id: inputId): void => {
		const currentId = id + 'Value';
		const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
		const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
		const parsedValue = `${hours}:${minutes}`;
		this.setState({ ...this.state, [currentId]: parsedValue });
	};

	renderTimePicker = (id: inputId, label: string): JSX.Element => {
		const { mobileView } = this.props;
		const timePickers = [
			{ pickerLabel: 'Heartbeat time', value: this.state.heartbeatValue },
			{ pickerLabel: 'Rainstorm mode time', value: this.state.rainstormModeEndValue },
			{ pickerLabel: 'Daily measurement time', value: this.state.dailyMeasurementTimeValue },
		];
		const currentValue = timePickers.find(({ pickerLabel }) => pickerLabel === label).value;

		return (
			<MuiPickersUtilsProvider utils={DateFnsUtils}>
				<GridItem xs={12} style={{ ...this.gridsStyle, marginBottom: mobileView ? '32px' : '10px' }}>
					<TimePicker
						id={id}
						ampm={false}
						label={label}
						value={null}
						defaultValue={currentValue}
						openTo='hours'
						onChange={(date) => this.handleTimeChange(date, id)}
						fullWidth
						views={['hours', 'minutes']}
						inputProps={{ value: currentValue }}
						InputProps={{ endAdornment: <AccessTimeIcon style={{ color: '#3c4858' }} /> }}
						disabled={!this.state.w2SystemIdValue && id == 'dailyMeasurementTime' || this.state.w2SystemIdValue && !['dailyMeasurementTime'].includes(id)}
					/>
				</GridItem>
			</MuiPickersUtilsProvider>
		);
	};

	renderSectionHeader = (number: string, title: string, first?: boolean): JSX.Element => {
		return (
			<GridItem xs={12} style={{ marginTop: first ? '0' : '24px' }}>
				<h6 style={{ color: '#3C4858', fontWeight: 700, fontSize: '15px', textTransform: 'uppercase', letterSpacing: '0.5px', margin: '0 0 4px 0' }}>
					{number}. {title}
				</h6>
				<Divider style={{ marginBottom: '10px' }} />
			</GridItem>
		);
	};

	renderSubsectionHeader = (numeral: string, title: string): JSX.Element => {
		const { classes } = this.props;
		return (
			<GridItem xs={12} style={{ marginTop: '14px', paddingLeft: '10px' }}>
				<h6 className={classes.cardCategory} style={{ fontWeight: 600, margin: '0 0 6px 0' }}>
					{numeral}. {title}
				</h6>
			</GridItem>
		);
	};

	render() {
		const {
			classes,
			saveParametersSettingsSuccessfully,
			saveParametersSettingsFailed,
			saveParametersSettingsFailedReason,
			closeSaveParametersSettingsNotification,
			mobileView,
			accountCategory
		} = this.props;

		const { isDataLoaded } = this.state;
		const titleStyle: CSSProperties = { color: '#3C4858' };
		const cardBodyStyle: CSSProperties = { display: 'flex', flexDirection: mobileView ? 'column' : 'row' };
		const columnStyles: CSSProperties = { display: 'flex', flexDirection: 'column', minWidth: 'calc(50% - 15px)' };
		// wisene-only fields on a W2 system - invisible to everyone else, see w2WiseneOnlyEditableIds
		const canEditW2Extended = !!this.state.w2SystemIdValue && accountCategory === 'wisene';

		return (
			<Card className='systemParametersSettings'>
				{!isDataLoaded ? (
					<div style={loaderStyleEmptyCard}>
						<Loading transform={0.85} height={90} width={70} color='gray' />
					</div>
				) : (
					<>
						<CardHeader color='info' icon>
							<CardIcon color='info'>
								<SystemIcon />
							</CardIcon>
							<GridItem xs={12}>
								<h5 className={classes.cardIconTitle} style={titleStyle}>
									Overall settings{' '}
								</h5>
							</GridItem>
						</CardHeader>
						<CardBody>
							<div style={cardBodyStyle}>
								<div style={columnStyles}>
									{this.renderSectionHeader('1', 'General', true)}
									{this.renderCustomTextField('name', 'Name', 'name')}
									{this.renderCustomTextField('w2SystemId', 'W2 System ID', 'name')}
									{this.renderCustomSelect('language', 'Language')}
									{this.renderCustomSelect('timeZone', 'Time zone')}
									{this.renderCustomTextField('communicationPeriod', 'Communication period', 'communicationPeriod')}
									{/* only W2 systems can be synced other way than on-line */}
									{this.state.w2SystemIdValue ? this.renderCustomSelect('syncSetting', 'Sync setting') : null}

									{this.renderSubsectionHeader('I', 'Season settings')}
									{this.renderDatePicker('winterSeasonStart', 'Winter season start')}
									{this.renderDatePicker('winterSeasonEnd', 'Winter season end')}
									{this.renderCustomTextField('summertimeMeasurementPeriod', 'Summertime measurement period (HH:mm)', 'measurementPeriod')}
									{this.renderCustomTextField('wintertimeMeasurementPeriod', 'Wintertime measurement period (HH:mm)', 'measurementPeriod')}

									{this.renderSubsectionHeader('II', 'Clients')}
									{this.renderClientAutocomplete('buyerClientId', 'Buyer')}
									{this.renderClientAutocomplete('servicePurchaserClientId', 'Service purchaser')}

									{this.renderSectionHeader('2', 'Location')}
									{this.renderSubsectionHeader('I', 'Coordinates')}
									{this.renderCustomTextField('latitude', 'Latitude', 'latitude')}
									{this.renderCustomTextField('longitude', 'Longitude', 'longitude')}

									{this.renderSubsectionHeader('II', 'Address')}
									{this.renderCustomSelect('country', 'Country')}
									{this.renderCustomTextField('addressCity', 'City', 'nullableString')}
									{this.renderCustomTextField('addressStreet', 'Street', 'nullableString')}
									{this.renderCustomTextField('addressBuildingNumber', 'Building number', 'buildingNumber')}
									{this.renderCustomTextField('addressPostalCode', 'Postal code', 'postalCode')}

									{this.renderSubsectionHeader('III', 'Rainstorm mode')}
									{this.renderCustomSelect('rainstormModeEnd', 'Rainstorm mode time')}
									{this.renderCustomSelect('autoRainstormModeEnabled', 'Auto rainstorm mode')}
								</div>
								<div style={{ margin: mobileView ? '0' : '15px' }}></div>
								<div style={columnStyles}>
									{this.renderSectionHeader('3', 'Measurements', true)}
									{this.renderSubsectionHeader('I', 'Measurements schedule')}
									{this.renderCustomSelect('dailyMeasurementOn', 'Daily measurement')}
									{this.renderTimePicker('dailyMeasurementTime', 'Daily measurement time')}
									{this.renderTimePicker('heartbeat', 'Heartbeat time')}

									{this.renderSubsectionHeader('II', 'Measurement sensitivity')}
									{this.renderCustomTextField('hysteresisForDistance', 'Hysteresis for distance', 'simpleInt')}
									{this.renderCustomTextField('hysteresisForAngle', 'Hysteresis for angle', 'angle')}
									{this.renderCustomTextField('angleChangeThreshold', 'Angle change threshold', 'angleChangeThreshold')}
									{this.renderCustomTextField('distanceChangeThreshold', 'Distance change threshold', 'distanceChangeThreshold')}
									{this.renderCustomTextField('inclinometerRange', 'Inclinometer range', 'inclinometerRange')}

									{this.renderSubsectionHeader('III', 'Obstruction detection')}
									{this.renderCustomSelect('obstructionDetectionThreshold', 'Obstruction detection threshold')}
									{this.renderCustomSelect('obstructionChangeThreshold', 'Obstruction change threshold')}
									{this.renderCustomSelect('obstructionCancelThreshold', 'Obstruction cancel threshold')}

									{canEditW2Extended && (
										<>
											{this.renderSectionHeader('4', 'WSN Remote access')}
											{this.renderCustomTextField('w2PublicIpAddress', 'Public IP address', 'nullableString')}
											{this.renderCustomSelect('w2PublicIpAddressDisabled', 'Public IP address disabled')}
											{this.renderCustomTextField('w2HttpPort', 'HTTP port', 'port')}
											{this.renderCustomTextField('w2HttpsPort', 'HTTPS port', 'port')}
											{this.renderCustomTextField('w2SshPort', 'SSH port', 'port')}
										</>
									)}
								</div>
							</div>
							<GridContainer>
								<GridItem xs={12}>
									{this.renderMobileNotifications()}
									{this.renderButton()}
								</GridItem>
							</GridContainer>
							{!mobileView ? (
								<>
									<Snackbar
										close
										closeNotification={() => {
											closeSaveParametersSettingsNotification();
											this.setState({ isLoaderRender: false });
										}}
										color='danger'
										message={'Save parameters settings failed' + (saveParametersSettingsFailedReason ? ': ' + saveParametersSettingsFailedReason : '')}
										open={saveParametersSettingsFailed}
										place='tc'
									/>
									<Snackbar
										close
										closeNotification={() => {
											closeSaveParametersSettingsNotification();
											this.setState({ isLoaderRender: false });
										}}
										color='success'
										message='Save parameters settings successfully'
										open={saveParametersSettingsSuccessfully}
										place='tc'
									/>
								</>
							) : null}
						</CardBody>
					</>
				)}
			</Card>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		saveParametersSettingsFailed: state.installer.saveParametersSettingsFailed,
		saveParametersSettingsSuccessfully: state.installer.saveParametersSettingsSuccessfully,
		saveParametersSettingsFailedReason: state.installer.saveParametersSettingsFailedReason,
		isMapLoading: state.dashboard.isMapLoading,
		mobileView: state.dashboard.mobileView,
		clients: state.dashboard.clients,
	};
};
const actions = {
	closeSaveParametersSettingsNotification,
	saveSystemSettings,
	saveW2SystemSettings,
	saveW2SystemExtendedSettings,
	getClients,
	saveSystemClients
};

const systemParametersSettingsWithStyles = dashboardStyle(SystemParametersSettings);
export default connect(mapStateToProps, actions)(systemParametersSettingsWithStyles);
